import TreatmentFullLayout from "../../components/TreatmentLayout";

const BladderProblems = () => {

const data = {
title:"Bladder Problem Treatment in Bhilwara",
subtitle:"Advanced bladder care at BBMH Hospital",

heading:"Best Bladder Specialist in Bhilwara",
description:"Bladder problems such as urine leakage, overactive bladder and urinary obstruction can affect daily life. At BBMH Hospital Bhilwara, advanced diagnosis and treatment ensures complete bladder health and improved quality of life.",

image:"https://cdn-icons-png.flaticon.com/512/4320/4320337.png",

sections:[
{
title:"Common Bladder Problems",
content:"",
list:[
"Urine leakage",
"Frequent urination",
"Overactive bladder",
"Urine blockage",
"Painful urination"
]
},
{
title:"Causes",
content:"",
list:[
"Infection",
"Prostate enlargement",
"Bladder stones",
"Nerve problems",
"Aging"
]
},
{
title:"Treatment Options",
content:"",
list:[
"Medication",
"Bladder training",
"Endoscopic treatment",
"Laser surgery",
"Advanced urology care"
]
},
{
title:"Why BBMH Hospital?",
content:"",
list:[
"Advanced equipment",
"Expert urologist",
"Accurate diagnosis",
"Affordable treatment"
]
}
],

faq:[
{q:"Is urine leakage treatable?",a:"Yes with proper treatment."},
{q:"When to see doctor?",a:"If symptoms persist more than few days."},
{q:"Is surgery needed?",a:"Only in severe cases."}
]
};

return <TreatmentFullLayout data={data}/>
};

export default BladderProblems;
